import ScreenWrapper from "crqlar-react-common/dist/components/ScreenWrapper";
import * as React from "react";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import {Stack} from "@mui/material";
import AvailabilityPlanner from "crqlar-react-common/dist/components/availability/AvailabilityPlanner";

interface Props {
    resourceId?: string
    disabled?: boolean
    titleSection?: React.ReactNode
    onAvailabilitiesChanged?: () => void
}

const ResourceAvailabilitiesTab = (props: Props) => {
    const {t} = useLocalize()

    return (
        <ScreenWrapper>
            {/*<Stack*/}
            {/*    sx={{*/}
            {/*        width: '100%',*/}
            {/*        maxWidth: '900px',*/}
            {/*        gap: 1,*/}
            {/*        alignSelf: 'center'*/}
            {/*    }}*/}
            {/*>*/}
                {/*Hidden for now - product decision.*/}
                {/*{props.titleSection}*/}

                {/*<AvailabilityPreview*/}
                {/*    entityId={props.resourceId}*/}
                {/*    noEntityTitle={t('Please save the resource to plan availability')}*/}
                {/*    noAvailabilitiesMessage={t('This resource has no availability plan. Please plan the availability to make it bookable.')}*/}
                {/*    disabled={props.disabled}*/}
                {/*/>*/}

                <AvailabilityPlanner
                    entityIdFromProps={props.resourceId}
                    withTitle={false}
                    onAvailabilitiesChanged={props.onAvailabilitiesChanged}
                />

            {/*</Stack>*/}
        </ScreenWrapper>
    )
}

export default ResourceAvailabilitiesTab
